import { render, staticRenderFns } from "./UploadInvoiceModal.vue?vue&type=template&id=3c8f5fd2&scoped=true"
import script from "./UploadInvoiceModal.vue?vue&type=script&lang=js"
export * from "./UploadInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./UploadInvoiceModal.vue?vue&type=style&index=0&id=3c8f5fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8f5fd2",
  null
  
)

export default component.exports